
import "es6-promise";

import Vue, { ComponentOptions } from "vue";

interface AboutPage extends Vue {}

export default Vue.extend({
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  watch: {}
});
